import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { ICategory, TServiceMap } from '@features/categories/typescript';
import styles from '@features/navigation/components/ExtraButtons/ExtraButtons.styles';
import prepareURLByCMSLink from '@utils/prepareURLByCMSLink';
type PropsType = {
  product: ICategory;
  serviceMap?: TServiceMap | null;
  onClose?: () => void | null;
};
const ExtraButtons = ({
  product,
  serviceMap = null,
  onClose = undefined
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  if (!product?.extra_buttons || !serviceMap && !onClose && product.extra_buttons.buttons.length === 0) return null;
  return <div sx={styles.marketingTopContentContainer}>
      {serviceMap && onClose && <Link href={`/${serviceMap[product.id]}`} onClick={onClose} sx={styles.marketingTopContent(product?.extra_buttons?.label_text_color)} className="nav_category-button">
          <span sx={styles.marketingButtonContent(product?.extra_buttons?.label_text_color)}>
            {product?.extra_buttons?.label_text ? product?.extra_buttons?.label_text : t('seeAllButton')}
          </span>
        </Link>}
      {product?.extra_buttons?.buttons?.length > 0 && product?.extra_buttons?.buttons.map(button => {
      if (button?.link?.path && button?.link?.text) {
        return <Link href={prepareURLByCMSLink(button.link) || '#'} key={button?.link?.path} sx={styles.marketingTopContent(button?.textColor)} onClick={onClose} className="nav_category-button">
                <span sx={styles.marketingButtonContent(button?.textColor)}>{button?.link?.text}</span>
              </Link>;
      }
      return null;
    })}
    </div>;
};
export default ExtraButtons;